
import './App.css';
import Home from './Home';
import Navbar from './Navbar';
import About from './About';
import Portfolio from './Portfolio';
import Expert from './Expert';
import Footer from './Footer';
function App() {
  return (
    <div className="App">
      
       
      <Navbar/>
      <Home/>
      <About/>
      <Portfolio/>
      <Expert/>
      <Footer/>
    </div>
  );
}

export default App;
